import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import PageFiveKeyProjectsDetails from './pageFiveKeyProjectsDetails';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 0,
        justifyContent: 'flex-start',
        width: '100%',
        paddingTop: 30,
        paddingLeft: 30,
        paddingRight: 30,
    },
    keyProjects: {
        marginTop: -40,
        paddingBottom: 3,
        fontFamily: 'Helvetica',
        fontSize: 16,
        color: '#F66616',
    },
    keyProjectsWithoutLogo: {
        marginTop: -7,
        paddingBottom: 3,
        fontFamily: 'Helvetica',
        fontSize: 16,
        color: '#F66616',
        position:'relative',
    },
});

const PageFiveKeyProjects = ({ prequalifyData, companyLogo }) => (
    <View style={styles.headerContainer}>
        {companyLogo !== ""  ? <Text style={styles.keyProjects}>Key Projects</Text> : <Text style={styles.keyProjectsWithoutLogo}>Key Projects</Text> }
        <View>
            <PageFiveKeyProjectsDetails items={prequalifyData} />
        </View>
    </View>
);

export default PageFiveKeyProjects;
